module.exports = __webpack_public_path__ + "static/img/iconTwo.8c14eb7f.svg";